import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
var token = cookies.get('token');

export function fetchUser () {
	return function(dispatch) {
		dispatch({type: 'FETCH_USER'});
	}
}

export function fetchUserFullData () {
	return function(dispatch) {
		axios.get(window.api+'user?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_USER_FULLDATA_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_USER_FULLDATA_REJECTED', payload: error});
			})
	}
}

export function fetchUserRoles () {
	return function(dispatch) {
		axios.get(window.api+'admin/findRoles?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_ROLES_FULLDATA_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_ROLES_FULLDATA_REJECTED', payload: error});
			})
	}
}

export function updateUserMailConfig (id, mail_driver, mail_host, mail_port, mail_username, mail_password, mail_encryption) {
	return function(dispatch) {
		axios.put(window.api+'user/'+id+'?token='+token, {
			id: id,
			mail_driver: mail_driver,
			mail_host: mail_host,
			mail_port: mail_port,
			mail_username: mail_username,
			mail_password: mail_password,
			mail_encryption: mail_encryption
		}).then((response) => {
			dispatch({type: 'UPDATE_USER_MAIL_CONFIG_FULFILLED', payload: response.data});
		})
		.catch((error) => {
			dispatch({type: 'UPDATE_USER_MAIL_CONFIG_REJECTED', payload: error});
		});
			
		return Promise.resolve();
	}
}